@if (visible().length > 0) {
    <div class="sem sem-list">
        <div class="sem-summary">
            <div class="sem-bar">
                @for (key of keys; track key) {
                    <i [class]="key" [style.flex]="stats().counts[key]"></i>
                }
                @if (stats().unrated > 0) {
                    <i class="none" [style.flex]="stats().unrated"></i>
                }
            </div>
            <div class="sem-counts">
                @for (key of keys; track key) {
                    <span [class]="key"><b>{{ stats().counts[key] }}</b> {{ labelOf(key) }}</span>
                }
            </div>
        </div>

        <div class="sem-list">
            @for (item of visible(); track $index) {
                <div class="sem-item">
                    <p class="sem-label">{{ item.label.trim() }}</p>
                    <span class="sem-scale">
                        @for (key of keys; track key) {
                            <span [class]="'sem-opt ' + key + (item.status === key ? ' sel' : '')"><i></i>{{ labelOf(key) }}</span>
                        }
                    </span>
                    @if (item.description?.trim(); as description) {
                        <p class="sem-desc">{{ description }}</p>
                    }
                </div>
            }
        </div>
    </div>

    @if (hidden() > 0) {
        <p class="more-items">+{{ hidden() }}</p>
    }
}
